import Vue from "vue";
import liff from "@line/liff";
import store from '@store'
// import lineGetProfileAndLogin from "@utils/line-get-profile-and-login";

export default function routeError(error, routeTo, callback, next) {
  console.log('TCL: Route -> error', error);

  if(error.status === 'MERCHANT_MEMBER_FRONT_MALICIOUS_QUERY_ORDER') {
    return next({ name: '404' })
  }

  if(error?.response?.data?.status === "API_THROTTLE") {
    return next();
  }

  if(error.code === 405 || error.code === 401) {
    if(liff.isInClient()) {
      /* lineGetProfileAndLogin({
       route: routeTo,
       next
       }) */
      alert('登入權杖過期：請重新打開視窗');
      store.dispatch('auth/logOut')
      liff.closeWindow();
    } else {
      const isShopPage = Vue.prototype.$bus.$globalIsJtailsMode && routeTo.path.includes('/shop')
      if (isShopPage) {
        return next({
          name: 'shop-logout',
          query: {
            // redirectFrom: location.pathname
            redirectFrom: routeTo.path
          }
        });
      } else
        return next({
          name: 'logout',
          query: {
            // redirectFrom: location.pathname
            redirectFrom: routeTo.path
          }
        });
    }
  } else {
    return callback
  }
}
